<template>
  <div>
    <v-responsive class="mx-auto overflow-visible">
      <div>
        <alert />
        <v-form
          ref="formProject"
          v-model="valid"
          lazy-validation
        >
          <v-stepper alt-labels v-model="step">
            <v-stepper-header class="mx-auto" style="max-width: 1000px">
              <v-stepper-step v-for="(item, index) in steps"
              :key="`step-${index}`"
              :step="index + 1"
              :complete="checkCompleteStep((index + 1))"
              edit-icon="$complete"
              @click="clickStep(index + 1, $event)"
              >
                {{ $t(item.text) }}
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <div class="mx-auto" style="max-width: 1000px;">
                  <v-card>
                    <v-card-text class="pa-8">
                      <h3 class="mb-4 text-center">{{ $t('Project information') }}</h3>
                      <v-row>
                        <v-col md="6">
                          <v-select
                            :label="$t('Type')"
                            :items="project_type"
                            :placeholder="$t('Select an option')"
                            v-model="form.type"
                            hide-details="auto"
                            :item-text="__attr"
                            outlined
                            dense
                            :rules="rules.type"
                          ></v-select>
                        </v-col>
                        <v-col md="6">
                            <v-text-field
                              :value="form.code"
                              :label="$t('Code')"
                              hide-details="auto"
                              outlined
                              dense
                              readonly
                            />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                            <v-text-field
                              v-model="form.name"
                              :label="$t('Name')"
                              outlined
                              hide-details="auto"
                              :rules="rules.name"
                              dense
                            />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <label>{{ $t('Target') }}</label>
                          <vue-editor v-model="form.target" :editor-toolbar="customToolbar"/>
                        </v-col>
                      </v-row>
                      <v-row v-show="form.type === 'technology'  || form.type === 'others'">
                        <v-col cols="12">
                            <v-textarea
                              v-model="form.reference"
                              :label="$t('Reference')"
                              outlined
                              hide-details="auto"
                              rows="3"
                            />
                        </v-col>
                      </v-row>
                      <v-row v-show="form.type === 'technology' || form.type === 'others'">
                         <v-col cols="12" v-if="referenceFiles.length">
                          <single-file-item v-for="file in referenceFiles"
                            :key="`file-${file.id}`"
                            :file="file"
                            showDelete
                            v-on:on-delete="deleteFile(file)"/>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model="form.reference_upload"
                                accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif"
                                counter
                                multiple
                                show-size
                                :label="$t('Reference documents')"
                                :placeholder="$t('Select your files')"
                                prepend-icon=""
                                append-icon="mdi-paperclip"
                                outlined
                                hide-details="auto"
                                dense
                                :rules="rules.document"
                              >
                              <template v-slot:selection="{ index, text }">
                                <v-chip
                                  v-if="index < 2"
                                  label
                                  small
                                >
                                  {{ text }}
                                </v-chip>
                                <span
                                  v-else-if="index === 2"
                                  class="overline mx-2"
                                >
                                  +{{ form.reference_upload.length - 2 }} {{ $t('File(s)') }}
                                </span>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>
                      <v-row v-show="form.type === 'technology' || form.type === 'others' ">
                        <v-col cols="12">
                            <v-textarea
                              v-model="form.application"
                              :label="$t('Application')"
                              outlined
                              hide-details="auto"
                              rows="3"
                            />
                        </v-col>
                      </v-row>
                      <v-row v-show="form.type === 'technology'  || form.type === 'others'">
                        <v-col cols="12" v-if="applicationFiles.length">
                          <single-file-item v-for="file in applicationFiles"
                            :key="`file-${file.id}`"
                            :file="file"
                            showDelete
                            v-on:on-delete="deleteFile(file)"/>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model="form.application_upload"
                                accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif"
                                counter
                                multiple
                                show-size
                                :label="$t('Application documents')"
                                :placeholder="$t('Select your files')"
                                prepend-icon=""
                                append-icon="mdi-paperclip"
                                outlined
                                hide-details="auto"
                                dense
                                :rules="rules.document"
                              >
                              <template v-slot:selection="{ index, text }">
                                  <v-chip
                                    v-if="index < 2"
                                    label
                                    small
                                  >
                                    {{ text }}
                                  </v-chip>
                                  <span
                                    v-else-if="index === 2"
                                    class="overline mx-2"
                                  >
                                    +{{ form.application_upload.length - 2 }} {{ $t('File(s)') }}
                                  </span>
                                </template>
                            </v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-stepper-content>
              <v-stepper-content step="2">
                <div class="mx-auto" style="max-width: 1000px">
                  <h3 class="mb-4 text-center">{{ $t('4P MIX') }}</h3>
                  <v-row>
                    <v-col md="6" lg="5" cols="12">
                      <v-card
                        outlined
                      >
                        <v-card-title>{{ $t('Product') }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                                <v-textarea
                                  v-model="form.product.functions"
                                  :label="$t('Functions')"
                                  outlined
                                  hide-details="auto"
                                  rows="2"
                                />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                                <v-textarea
                                  v-model="form.product.usage"
                                  :label="$t('Usage')"
                                  outlined
                                  hide-details="auto"
                                  rows="2"
                                />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                                <v-textarea
                                  v-model="form.product.packages"
                                  :label="$t('Packages')"
                                  outlined
                                  hide-details="auto"
                                  rows="2"
                                />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                                <v-textarea
                                  v-model="form.product.services"
                                  :label="$t('Services')"
                                  outlined
                                  hide-details="auto"
                                  rows="2"
                                />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col md="6" lg="5" cols="12" offset-lg="2">
                      <v-card
                        outlined
                      >
                        <v-card-title>{{ $t('Price') }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                                <vuetify-money
                                  v-model="form.price.price"
                                  v-bind:label="$t('Our price')"
                                  v-bind:readonly="false"
                                  v-bind:disabled="false"
                                  v-bind:outlined="true"
                                  v-bind:clearable="false"
                                  v-bind:hide-details="'auto'"
                                  v-bind:options="{
                                    locale: 'en-US',
                                    prefix: 'VND',
                                    suffix: '',
                                    length: 16,
                                    precision: 0
                                  }"
                                  ></vuetify-money>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <vuetify-money
                                v-model="form.price.competitor_price"
                                v-bind:label="$t('Competitor price')"
                                v-bind:readonly="false"
                                v-bind:disabled="false"
                                v-bind:outlined="true"
                                v-bind:clearable="false"
                                v-bind:hide-details="'auto'"
                                v-bind:options="{
                                  locale: 'en-US',
                                  prefix: 'VND',
                                  suffix: '',
                                  length: 16,
                                  precision: 0
                                }"
                                ></vuetify-money>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                                <v-textarea
                                  v-model="form.price.note"
                                  :label="$t('Note')"
                                  outlined
                                  hide-details="auto"
                                  rows="3"
                                />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="6" lg="5" cols="12">
                      <v-card
                        outlined
                      >
                        <v-card-title>{{ $t('Places') }}</v-card-title>
                        <v-card-text>
                          <v-row v-for="(place, index) in form.places" :key="`place-${index}`">
                            <v-col cols="12">
                                <div style="position: relative;">
                                  <v-textarea
                                      v-model="place.selling_chanel"
                                      :label="$t('Place') + ` ${index + 1}`"
                                      outlined
                                      hide-details="auto"
                                      :rules="rules.places.selling_chanel"
                                      rows="2"
                                    />
                                  <v-btn
                                    color="red" dark small fab absolute top right
                                    @click="deletePlace(place, index, $event)"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </div>
                            </v-col>
                          </v-row>
                          <div class="text-center mt-3">
                            <v-btn
                              color="primary"
                              dark
                              outlined
                              @click="addPlace($event)"
                            >
                              {{ $t('Add') }} <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col md="6" lg="5" cols="12" offset-lg="2">
                      <v-card
                        outlined
                      >
                        <v-card-title>{{ $t('Promotions') }}</v-card-title>
                        <v-card-text>
                        <v-row v-for="(promotion, index) in form.promotions" :key="`promotion-${index}`">
                            <v-col cols="12">
                                <div style="position: relative;">
                                  <v-textarea
                                      v-model="promotion.name"
                                      :label="$t('Promotion') + ` ${index + 1}`"
                                      outlined
                                      hide-details="auto"
                                       :rules="rules.promotions.name"
                                      rows="2"
                                    />
                                  <v-btn
                                    color="red" dark small fab absolute top right
                                    @click="deletePromotion(promotion, index, $event)"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </div>
                            </v-col>
                          </v-row>
                          <div class="text-center mt-3">
                            <v-btn
                              color="primary"
                              dark
                              outlined
                              @click="addPromotion($event)"
                            >
                              {{ $t('Add') }} <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-stepper-content>
              <v-stepper-content step="3">
                <div class="mx-auto" style="max-width: 1000px">
                <h3 class="mb-4 text-center">{{ $t('SWOT') }}</h3>
                  <v-row>
                    <v-col md="6" lg="5" cols="12">
                     <v-card>
                       <v-card-text>
                          <v-textarea
                          v-model="form.swot.strength"
                          :label="$t('Strength')"
                          outlined
                          hide-details="auto"
                          rows="5"
                        />
                       </v-card-text>
                     </v-card>
                    </v-col>
                    <v-col md="6" lg="5" cols="12" offset-lg="2">
                      <v-card>
                       <v-card-text>
                         <v-textarea
                          v-model="form.swot.weakness"
                          :label="$t('Weakness')"
                          outlined
                          hide-details="auto"
                          rows="5"
                        />
                       </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="6" lg="5" cols="12">
                      <v-card>
                       <v-card-text>
                          <v-textarea
                          v-model="form.swot.opportunities"
                          :label="$t('Opportunities')"
                          outlined
                          hide-details="auto"
                          rows="5"
                        />
                       </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col md="6" lg="5" cols="12" offset-lg="2">
                      <v-card>
                       <v-card-text>
                           <v-textarea
                          v-model="form.swot.threats"
                          :label="$t('Threats')"
                          outlined
                          hide-details="auto"
                          rows="5"
                        />
                       </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-stepper-content>
              <v-stepper-content step="4">
                <div style="max-width: 1400px" class="mx-auto">
                  <h3 class="mb-4 text-center">{{ $t('Assignment') }}</h3>
                  <v-card elevation="10" v-for="(item, index) in form.tasks" :key="`task-${index}`" class="mb-5">
                    <v-card-title>
                      #{{ index + 1 }}
                      <v-spacer/>
                      <v-btn
                          v-show="index > 0 && !item.is_first"
                          color="red"
                          fab
                          dark
                          small
                          @click="deleteTask(item, index, $event)"
                        >
                          <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" sm="6" lg="5">
                          <div>
                            <v-text-field
                                v-model="item.name"
                                hide-details="auto"
                                :label="$t('Task')"
                                dense
                                outlined
                                :rules="rules.tasks.name"
                                :readonly="index === 0"
                              />
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" lg="3">
                          <template v-if="index === 0">
                            <v-text-field
                                :value="userName"
                                hide-details="auto"
                                :label="$t('Assign to')"
                                dense
                                outlined
                                readonly
                              />
                            </template>
                            <template v-else>
                              <v-autocomplete
                                auto-select-first
                                clearable
                                :label="$t('Assign to')"
                                :items="selectUsers"
                                :placeholder="$t('Select an option')"
                                v-model="item.user_id"
                                outlined
                                hide-details="auto"
                                dense
                                :rules="rules.tasks.user_id"
                              />
                            </template>
                        </v-col>
                        <v-col cols="12" sm="6" lg="2">
                          <datepicker v-model="item.due_date" :label="$t('Due date')" :dense="true" :outlined="true"/>
                        </v-col>
                        <v-col cols="12" sm="6" lg="2">
                          <v-text-field
                              v-model.number="item.weight"
                              type="number"
                              :rules="rules.weight"
                              :label="$t('Weight')"
                              outlined
                              hide-details="auto"
                              dense
                            ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-switch
                        v-model="item.show_target"
                        :label="$t('Show more')"
                      ></v-switch>
                      <div v-show="item.show_target">
                        <v-row>
                          <v-col cols="12" md="4" lg="4">
                            <v-select
                              :label="$t('Priority')"
                              :items="task_priority"
                              :placeholder="$t('Select an option')"
                              v-model="item.priority"
                              hide-details="auto"
                              outlined
                              dense
                            >
                              <template v-slot:item="{ item }">
                                {{ __attr(`priority.${item.value}`) }}
                              </template>
                              <template v-slot:selection="{ item }">
                                {{ __attr(`priority.${item.value}`) }}
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4" lg="4">
                            <datepicker v-model="item.start_date" :dense="true" :outlined="true" :label="$t('Start date')"/>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-file-input
                                v-model="item.files_upload"
                                accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif"
                                counter
                                multiple
                                show-size
                                :label="$t('Documents')"
                                :placeholder="$t('Select your files')"
                                prepend-icon=""
                                append-icon="mdi-paperclip"
                                outlined
                                hide-details="auto"
                                dense
                                :rules="rules.document"
                              >
                              <template v-slot:selection="{ index, text }">
                                  <v-chip
                                    v-if="index < 2"
                                    label
                                    small
                                  >
                                    {{ text }}
                                  </v-chip>
                                  <span
                                    v-else-if="index === 2"
                                    class="overline mx-2"
                                  >
                                    +{{ item.files_upload.length - 2 }} {{ $t('File(s)') }}
                                  </span>
                                </template>
                            </v-file-input>
                          </v-col>
                        </v-row>
                        <div v-if="item.files && item.files.length">
                          <single-file-item v-for="file in item.files"
                            :key="`file-${file.id}`"
                            :file="file"
                            showDelete
                            v-on:on-delete="deleteTaskFile(index, file)"/>
                        </div>
                        <v-row>
                          <v-col cols="12">
                            <label>{{ $t('Target') }}</label>
                            <vue-editor v-model="item.target" class="editorTaskTarget" :editor-toolbar="customToolbar"/>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                  <div class="text-center mt-3">
                    <v-btn
                      color="primary"
                      dark
                      outlined
                      @click="addTask($event)"
                    >
                      {{ $t('Add') }} <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <div class="text-center my-5">
            <v-btn color="secondary" :disabled="step === 1" @click="back($event)" class="mr-3">{{ $t('Back') }}</v-btn>
            <v-btn color="primary" v-show="step < 4" @click="next($event)">{{ $t('Continue') }}</v-btn>
            <v-btn color="primary" v-show="step === 4" @click="submit($event)" :disabled="submitted">{{ $t('Submit') }}</v-btn>
          </div>
        </v-form>
      </div>
    </v-responsive>
  </div>
</template>

<script>
import Datepicker from '@/components/Datepicker'
import { get, call } from 'vuex-pathify'
import validation from '@utils/validation'
import Alert from '@components/Alert'
import SingleFileItem from '@components/SingleFileItem'
import { VueEditor } from 'vue2-editor'
import _ from 'lodash'
import VuetifyMoney from '@components/VuetifyMoney'

export default {
  name: 'ProjectCreate',
  components: {
    Datepicker, Alert, SingleFileItem, VueEditor, VuetifyMoney
  },
  data: () => ({
    step: 1,
    valid: true,
    submitted: true,
    steps: [
      {
        text: 'Basic'
      },
      {
        text: '4P MIX'
      },
      {
        text: 'SWOT'
      },
      {
        text: 'Assignment'
      }
    ],
    form: {
      id: '',
      name: '',
      type: '',
      target: '',
      reference: '',
      reference_upload: null,
      application: '',
      application_upload: null,
      tasks: [],
      places: [],
      price: {
        price: '',
        competitor_price: '',
        note: ''
      },
      product: {
        functions: '',
        usage: '',
        packages: '',
        services: ''
      },
      promotions: [],
      swot: {
        strength: '',
        weakness: '',
        opportunities: '',
        threats: ''
      },
      files: [],
      // delete
      files_delete: [],
      tasks_delete: [],
      places_delete: [],
      promotions_delete: [],
      task_files_delete: []
    },
    rules: {
      type: [
        (v) => validation.required(v)
      ],
      name: [
        (v) => validation.required(v),
        v => validation.minlength(v, 6)
      ],
      tasks: {
        user_id: [(v) => validation.required(v)],
        name: [(v) => validation.required(v)]
      },
      promotions: {
        name: [(v) => validation.required(v)]
      },
      places: {
        selling_chanel: [(v) => validation.required(v)]
      },
      price: [
        (v) => validation.number(v),
        (v) => validation.min(v, 0)
      ],
      document: [
        (v) => validation.accept(v),
        (v) => validation.arrayMax(v, 5),
        (v) => validation.filesize(v, 10 * 1024 * 1024)
      ],
      weight: [
        (v) => validation.number(v),
        (v) => validation.min(v, 0),
        (v) => validation.max(v, 100)
      ]
    },
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ['bold', 'italic', 'underline', 'strike'],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' }
      ],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }, { background: [] }],
      ['link'],
      ['clean']
    ]
  }),
  computed: {
    ...get('common', [
      'project_type',
      'task_priority'
    ]),
    selectUsers: get('user/selectUsers'),
    userId: get('user/id'),
    userName: get('user/name'),

    projectId() {
      return this.$route.params.id
    },

    applicationFiles() {
      return this.form.files.filter(function(item) {
        return item.category === 'application'
      })
    },

    referenceFiles() {
      return this.form.files.filter(function(item) {
        return item.category === 'reference'
      })
    }
  },
  async created() {
    const id = this.projectId
    if (!id) {
      alert(this.$t('Something went wrong!'))
      this.$router.push({ name: 'projects.index' })
    } else {
      const data = {}

      const params = {
        _include: [
          'tasks.files',
          'files',
          'product',
          'places',
          'promotions',
          'price',
          'swot'
        ]
      }

      const { project } = await this.getProject({ id, params })

      // Check user
      if (this.userId !== project.user_id) {
        this.$router.replace({ name: 'error.403' })
      }

      // Check status
      if (['completed', 'reviewed'].includes(project.status)) {
        alert(this.$t('You can not edit this project.'))
        this.$router.push({ name: 'projects.show', params: { id } })
      }

      for (const [key, value] of Object.entries(project)) {
        if (!value) {
          continue
        }
        if (['points', 'rate', 'completed_at', 'created_at'].indexOf(key) !== -1) {
          continue
        }
        data[key] = value
      }
      this.$set(this, 'form', {
        ...this.form,
        ...data
      })
      this.submitted = false
    }
  },
  mounted() {
    this.fetchAllUsers()
  },
  methods: {
    hideAlert: call('alert/hide'),
    loading: call('app/setLoading'),
    fetchAllUsers: call('user/all'),
    handleSubmit: call('project/update'),
    getProject: call('project/show'),

    clickStep(step, e) {
      e.preventDefault()
      if (this.form.type !== 'product' && (step === 2 || step === 3)) {
        alert(this.$t('This step is not support.'))
        return false
      }
      this.step = step
    },
    checkCompleteStep(step) {
      if (this.form.type === 'product') {
        return this.step > step
      } else {
        if (step === 2 || step === 3) {
          return false
        }
        return this.step > step
      }
    },
    back(e) {
      e.preventDefault()
      if (this.step === 4 && this.form.type !== 'product') {
        this.step = 1
      } else {
        this.step--
      }
      return false
    },
    next(e) {
      e.preventDefault()
      if (this.step === 1 && this.form.type !== 'product') {
        this.step = 4
      } else {
        this.step++
      }
      return false
    },
    async submit(e) {
      e.preventDefault()
      const valid = this.$refs.formProject.validate()
      if (!valid) {
        this.step = 1
        alert(this.$t('Please check data before submit!'))
        return false
      } else {
        const totalWeight = this.form.tasks.reduce(function(accumulator, currentValue) {
          return accumulator + (currentValue.weight || 0)
        }, 0)
        if (totalWeight > 100) {
          alert(this.$t('The total weight should be 100.'))
          return false
        }

        const formData = _.cloneDeep(this.form)

        formData.tasks = formData.tasks.map(item => ({
          id: item.id || null,
          user_id: item.user_id,
          name: item.name,
          due_date: item.due_date,
          start_date: item.start_date,
          target: item.target,
          files_upload: item.files_upload,
          weight: item.weight,
          priority: item.priority
        }))

        if (formData.type === 'product') {
          formData.application_upload = null
          formData.reference_upload = null
          formData.application = null
          formData.reference = null
        } else {
          formData.places = []
          formData.price = {}
          formData.product = {}
          formData.promotions = []
          formData.swot = {}
        }
        this.submitted = true
        this.hideAlert()
        this.loading(true)
        const status = await this.handleSubmit(formData)
        this.loading(false)
        if (!status) {
          this.submitted = false
        } else {
          this.$router.push({ replace: true, name: 'projects.show', params: { id: this.projectId } })
        }
      }
    },
    addPlace(e) {
      e.preventDefault()
      this.form.places.push({
        selling_chanel: ''
      })
      return false
    },
    deletePlace(item, index, e) {
      e.preventDefault()
      if (item.id) {
        if (confirm(this.$t('Are you sure to delete item?'))) {
          this.form.places_delete.push(item.id)
          this.form.places.splice(index, 1)
        }
      } else {
        this.form.places.splice(index, 1)
      }
      return false
    },
    addPromotion(e) {
      e.preventDefault()
      this.form.promotions.push({
        name: ''
      })
      return false
    },
    deletePromotion(item, index, e) {
      e.preventDefault()
      if (item.id) {
        if (confirm(this.$t('Are you sure to delete item?'))) {
          this.form.promotions_delete.push(item.id)
          this.form.promotions.splice(index, 1)
        }
      } else {
        this.form.promotions.splice(index, 1)
      }
      return false
    },
    deleteTask(item, index, e) {
      e.preventDefault()
      if (item.id) {
        if (confirm(this.$t('Are you sure to delete item?'))) {
          this.form.tasks_delete.push(item.id)
          this.form.tasks.splice(index, 1)
        }
      } else {
        this.form.tasks.splice(index, 1)
      }
      return false
    },
    deleteFile(item) {
      if (confirm(this.$t('Are you sure to delete item?'))) {
        this.form.files_delete.push(item.id)
        const index = this.form.files.findIndex(function(file) {
          return file.id === item.id
        })
        this.form.files.splice(index, 1)
      }
      return false
    },
    deleteTaskFile(taskIndex, item) {
      if (confirm(this.$t('Are you sure to delete item?'))) {
        this.form.task_files_delete.push(item.id)
        const index = this.form.tasks[taskIndex].files.findIndex(function(file) {
          return file.id === item.id
        })
        this.form.tasks[taskIndex].files.splice(index, 1)
      }
      return false
    },
    addTask(e) {
      e.preventDefault()
      this.form.tasks.push({
        user_id: '',
        name: '',
        due_date: null,
        start_date: null,
        target: '',
        files_upload: null,
        weight: null,
        priority: 2,
        is_first: 0
      })
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.v-stepper {
  box-shadow: none !important;
  .v-stepper__header {
    box-shadow: none !important;
  }
}
.theme--light.v-stepper {
  background: transparent;
}
.editorTaskTarget {
  .ql-editor { min-height:200px }
}
@media only screen and (max-width: 959px) {
  .v-stepper__label {
    display: flex !important;
  }
  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 100% !important;
  }
}
</style>
